// packages/web-ui/src/components/composer/ChipStrip.tsx
//
// Story W2-S7 AC #1 Row 2 — horizontal strip of resolved mention chips.
// Renders one `<MentionChip>` (from the W4-S6 mention-helper barrel) per
// chip in `chips`, plus an `[×]` removal button. Hidden when empty.

import type { JSX } from 'react';
import { MentionChip } from '../mention-helper/index.js';
import { AMBIGUOUS_ENTITY_ID, type ComposerChip } from '../../state/composer.js';

export interface ChipStripProps {
  chips: ReadonlyArray<ComposerChip>;
  onRemove: (chipId: string) => void;
  onChipClick?: (chip: ComposerChip) => void;
}

export function ChipStrip(props: ChipStripProps): JSX.Element | null {
  const { chips, onRemove, onChipClick } = props;
  if (chips.length === 0) return null;
  return (
    <div
      data-testid="composer-chip-strip"
      className="flex h-6 items-center gap-1 overflow-x-auto"
    >
      {chips.map((chip) => {
        const isAmbiguous = chip.entityId === AMBIGUOUS_ENTITY_ID;
        return (
          <span
            key={chip.id}
            data-testid="composer-chip"
            data-chip-id={chip.id}
            data-ambiguous={isAmbiguous ? 'true' : 'false'}
            onClick={() => {
              if (onChipClick !== undefined && !isAmbiguous) onChipClick(chip);
            }}
            className={isAmbiguous ? 'rounded ring-1 ring-amber-400' : undefined}
          >
            <MentionChip
              entityId={chip.entityId ?? AMBIGUOUS_ENTITY_ID}
              kind={chip.kind}
              label={chip.chipText}
              qualifiedName={chip.qualifiedName}
              onRemove={() => {
                onRemove(chip.id);
              }}
            />
          </span>
        );
      })}
    </div>
  );
}
